<template>
  <slot :shadow-style="shadowStyle" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useMediaShadow } from "../composables/useMediaShadow";

export interface ShadowProps {
  enabled?: boolean;
  blur?: number;
  offsetX?: number;
  offsetY?: number;
  color?: string;
  opacity?: number;
}

interface Props {
  shadowProps?: ShadowProps;
}

const props = defineProps<Props>();

const { shadowStyle } = useMediaShadow(computed(() => props.shadowProps));
</script>